<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
            <v-container class="contain-width">
                <h1 class="md-display-2 white--text mb-6">{{ $t('headings.How it works') }}</h1>
                <v-row>
                    <v-col
                            cols="12"
                            sm="6"
                            md="4"
                            v-for="item in guides"
                            v-bind:key="item.id"
                    >
                        <v-card
                                class="mx-auto product-card"
                                outlined
                        >
                            <v-card-title class="headline primary--text">{{item.heading}}</v-card-title>

                            <v-img
                                    class="white--text align-end mb-2"
                                    height="200px"
                                    :src="require('@/assets/' + item.image)"
                            >

                            </v-img>

                            <v-card-actions>
                                <v-btn class="small" tile elevation="0" color="primary" @click="navigate('guide', item)">
                                    {{ $t('buttons.Find out more') }}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import Footer from './Footer'
    import {i18n} from "../i18n";
    import axios from 'axios/index'
    import {mapState} from "vuex";

    export default {
        name: "HowItWorks",
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('headings.How it works'),
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'description', content: i18n.t('How it works; watch our video guides to answer your frequently asked questions') }
            ]
          }
        },
        components: {
            'Footer': Footer
        },
        data () {
            return {
                guides: []
            }
        },
        mounted () {
            this.$gtag.pageview({
                page_path: '/how-it-works'
            })

            document.getElementById("scrolling-content").scrollTop = 0

            window.prerenderReady = true;

            this.loadGuides();
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            navigate(routeName, item) {
                this.$router.push({name: routeName, params: { slug: item.slug }})
            },
            loadGuides() {

              this.loading = true
              this.guides = [];

              const instance = axios.create({
                baseURL: process.env.VUE_APP_NEOTAG_HOSTNAMES.split(",").includes(window.location.hostname) ? process.env.VUE_APP_API_HOST_NEOTAG : process.env.VUE_APP_API_HOST,
                headers: {'Accept-Language': this.locale},
                withCredentials: true,
              });

              instance
                  .get('/api/guides')
                  .then(response => {
                    this.guides = response.data.data
                  })
                  .catch(error => {
                    console.log(error)
                  })
            },
        }
    }
</script>

<style scoped>

    button {
        text-transform: none;
    }
    .product-card {
        border-radius: 15px;
        border: none !important;
        height: 100%;
        padding-bottom: 60px;
    }
    .product-card .v-card__actions {
        padding-left: 15px;
        padding-bottom: 15px;
        position: absolute;
        bottom: 0;
    }

</style>
